import { atom } from 'jotai';
import { KpiWorkLogFormContextValue } from './types';
import {
  AggregationGroupBy,
  AllCommentsGenericQuery,
  LogsTemplate,
  ShiftType,
  WorkpackTypeFilterOption,
  WorkpackWbsFilterOption,
} from '@/__generated__/graphql';
import { atomWithReset } from 'jotai/utils';

export const kpiWorkLogFormContextAtom = atom<KpiWorkLogFormContextValue | null>(null);

export const kpiPanelOpen = atom(false);

export const selectedWorklogsTemplate = atom<LogsTemplate | undefined>();

// Selected workpack ID for KPI tracker
export const selectedWorkpackIdForKpiTracker = atom<string | undefined>();

export const selectedDate = atom<Date>(new Date());

export const selectedDeploymentIds = atomWithReset<string[]>([]);

export const selectedWorkpackTypes = atomWithReset<WorkpackTypeFilterOption[]>([]);

export const visibleColumnKeys = atomWithReset<string[] | undefined>(undefined);

export const selectedDateAggregation = atomWithReset<AggregationGroupBy>(AggregationGroupBy.Daily);

export const selectedWbsFilter = atomWithReset<WorkpackWbsFilterOption | undefined>(undefined);

export const selectedStartDate = atomWithReset<Date | undefined>(undefined);
export const selectedEndDate = atomWithReset<Date | undefined>(undefined);
export const shouldShowPobInput = atom<boolean>(false);

export const selectedShift = atom<ShiftType>(ShiftType.Day);

export const workpackComments = atom<
  Array<NonNullable<AllCommentsGenericQuery['allComments']>[number]>
>([]);
